<kendo-dialog title="Add Reason for Delay" (close)="closeDialog()" [width]="700">

    <div class="dialog-body">
        <div class="loading-container" *ngIf="loadSpinner">
            <kendo-loader *ngIf="loadSpinner" type="converging-spinner" size="large"></kendo-loader>
        </div>

        <div *ngIf="form">
            <form class="k-form k-form-md" [formGroup]="form">
                <div class="layout">
                    <div class="contact-details k-my-4" *ngIf="evalutionSk">
                        <div class="k-d-inline-flex k-mb-2">
                            <h3 class="k-m-0"> Assessment Name</h3>
                            <div class="margin">
                                <h4> {{title}} </h4>
                            </div>
                        </div>
                    </div>

                    <div class="contact-details k-my-4">
                        <div class="k-d-inline-flex k-mb-2">
                            <h3 class="k-m-0"> Reason for Delay</h3>
                        </div>

                        <div class="k-d-flex k-justify-content-stretch">
                            <div class="k-ml-2 k-mr-2 k-mb-2 k-w-full" formArrayName="reasons">
                                <ng-container *ngFor="let delay of reasons?.controls; let i = index;"
                                    [formGroupName]="i">
                                    <kendo-formfield>
                                        <kendo-dropdownlist [data]="reasonForDelay" [rounded]="'large'"
                                            [valuePrimitive]="true" [textField]="'description'"
                                            formControlName="reasonForDelayId" [valueField]="'id'"
                                            [size]="'medium'"></kendo-dropdownlist>
                                        <kendo-formerror>Error: Selection is mandatory</kendo-formerror>
                                    </kendo-formfield>
                                    <kendo-formfield class="k-my-2 k-w-full">
                                        <kendo-floatinglabel text="Description" class="k-w-full">
                                            <kendo-textbox [size]="'medium'" rounded="large" [fillMode]="'outline'"
                                                formControlName="description">
                                            </kendo-textbox>
                                        </kendo-floatinglabel>
                                        <kendo-formerror>Error: Please enter description</kendo-formerror>
                                    </kendo-formfield>
                                    <div class="divider !k-mt-6 !k-mb-6"></div>
                                </ng-container>
                                <button kendoButton [svgIcon]="svgPlus" size="large" rounded="large" fillMode="outline"
                                    themeColor="info" (click)="addReasonForDelay()">
                                    Add Reason For Delay
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </form>
        </div>
    </div>

    <kendo-dialog-actions>
        <div class=" k-mt-2 k-text-right margin  ">
            <div class="action-btns   footer">
                <div class="action-btns__right">
                    <button kendoButton size="large" rounded="large" fillMode="outline" themeColor="error"
                        (click)="closeDialog()">
                        Cancel
                    </button>
                    &nbsp;
                    <button kendoButton size="large" (click)="submit()" [disabled]="!form.valid" rounded="large"
                        fillMode="solid" themeColor="primary">
                        Submit
                    </button>
                </div>
            </div>
        </div>
    </kendo-dialog-actions>
</kendo-dialog>